import React from 'react';
import './RiskAssessment.scss';

const RiskAssessment = ({ jwt, adminCompanyContext }) => {
  return (
    <div className={'risk-assessment'}>
      <h1>Hello World from Risk Assessment!</h1>
    </div>
  );
};

export default RiskAssessment; 